import {useRef} from 'react'
import { useLocation } from 'react-router-dom'
import {useOpen} from 'common/hooks'
import {Modal, ListTabsPanel} from 'common/components'
import {Button} from 'common/components/V2'
import useStore from 'base/store'
import { PermissionType } from 'common/types'
import {NewRequest} from '..'

const tabs = [
  {
    key: '',
    label: 'Loan Request',
  },
  {
    key: 'drawdown',
    label: 'Drawdown Request',
  },
  {
    key: 'variation',
    label: 'Variation Request',
  },
  {
    key: 'default',
    label: 'Default Request',
  },
  {
    key: 'journal',
    label: 'Journal Request',
  },
]

export default function RequestsPanel() {
  const location = useLocation()
  const path = location.pathname.split('/').filter((x:string) => !!x)
  return (
    <ListTabsPanel
      path="requests"
      tabs={tabs}
      // action={(role.coordinator || role.manager) && <CreateRequest />}
      action={(path?.length === 1) ? <CreateRequest /> : undefined}
    />
  )
}

const CreateRequest = () => {
  const permissions: PermissionType[] = useStore((state) => state.permissions)
  
  const [isOpen, handleOpen, handleClose] = useOpen()
  const modalWrapRef = useRef()

  return (
    (!!permissions?.includes('create a loan request')) ?
    <>
      <Button onClick={handleOpen}
        $color='cyan' $size='small'
      >
        Create request
      </Button>
      <Modal
        open={isOpen}
        title="New request"
        wrapProps={{ref: modalWrapRef}}
        // onCancel={handleClose}
      >
        <NewRequest modalWrapRef={modalWrapRef} onClose={handleClose} />
      </Modal>
    </>
    :
    null
  )
}
